var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataItem.bank_account)?_c('b-list-group-item',[_c('div',{staticClass:"font-weight-bold text-primary"},[_vm._v(" Banka Hesabı ")]),_c('div',[_vm._v(_vm._s(_vm.dataItem.bank_account))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }